import { EqualityCondition } from 'core/flow/entities';

type AnalyticsCondition = Record<string, EqualityCondition>;

export enum AnalyticsType {
  FACEBOOK_PIXEL = 'FACEBOOK_PIXEL',
  BING_ADS = 'BING_ADS',
  TIK_TOK = 'TIK_TOK',
  TABOOLA = 'TABOOLA',
  AXON = 'AXON',
  SNAPCHAT = 'SNAPCHAT',
}

interface AnalyticsNumericalId {
  id: string;
}

interface AnalyticsAttribute extends AnalyticsNumericalId {
  condition?: AnalyticsCondition;
}

export type FacebookAnalytics = {
  type: AnalyticsType.FACEBOOK_PIXEL;
  attributes: Array<AnalyticsAttribute>;
};

export type BingAdsAnalytics = {
  type: AnalyticsType.BING_ADS;
  attributes: Array<AnalyticsAttribute>;
};

export type TikTokAnalytics = {
  type: AnalyticsType.TIK_TOK;
  attributes: Array<AnalyticsAttribute>;
};

type TaboolaAnalytics = {
  type: AnalyticsType.TABOOLA;
  attributes: Array<AnalyticsAttribute>;
};

type AxonAnalytics = {
  type: AnalyticsType.AXON;
  attributes: Array<AnalyticsAttribute>;
};

export type SnapchatAnalytics = {
  type: AnalyticsType.SNAPCHAT;
  attributes: Array<AnalyticsAttribute>;
};

export type FunnelAnalytics = Array<
  | FacebookAnalytics
  | BingAdsAnalytics
  | TikTokAnalytics
  | TaboolaAnalytics
  | AxonAnalytics
  | SnapchatAnalytics
>;

export const isFacebookPixel = (item: FunnelAnalytics[number]): item is FacebookAnalytics =>
  item.type === AnalyticsType.FACEBOOK_PIXEL;

export const isBingAds = (item: FunnelAnalytics[number]): item is BingAdsAnalytics =>
  item.type === AnalyticsType.BING_ADS;

export const isTikTok = (item: FunnelAnalytics[number]): item is TikTokAnalytics =>
  item.type === AnalyticsType.TIK_TOK;

export const isTaboola = (item: FunnelAnalytics[number]): item is TaboolaAnalytics =>
  item.type === AnalyticsType.TABOOLA;

export const isAxon = (item: FunnelAnalytics[number]): item is AxonAnalytics =>
  item.type === AnalyticsType.AXON;

export const isSnapchat = (item: FunnelAnalytics[number]): item is SnapchatAnalytics =>
  item.type === AnalyticsType.SNAPCHAT;
